export const jurisprudenceTypes = [
  { id: "Por reiteración", name: "Por reiteración" },
  { id: "Por contradicción", name: "Por contradicción" },
  { id: "Por precedente", name: "Por precedente" },
];
